import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3, Users, LayoutDashboard, ArrowRight, FileText } from 'lucide-react';

const cards = [
  {
    title: 'CRM Leads',
    description: 'Pipeline de leads, seguimiento y ventas. Ver tablero de follow-ups y métricas.',
    href: '/admin/crm',
    icon: BarChart3,
    color: 'bg-purple-500',
  },
  {
    title: 'Usuarios',
    description: 'Gestión de usuarios, acceso a membresía, suscripciones y contraseñas.',
    href: '/admin/users',
    icon: Users,
    color: 'bg-blue-500',
  },
  {
    title: 'Comprobantes',
    description: 'Generar comprobantes de entrega de servicio para alumnos (PDF).',
    href: '/admin/receipts',
    icon: FileText,
    color: 'bg-emerald-500',
  },
  {
    title: 'Más secciones',
    description: 'Configuración, reportes y otras herramientas (próximamente).',
    href: '/admin',
    icon: LayoutDashboard,
    color: 'bg-slate-400',
    disabled: true,
  },
];

export default function AdminDashboard() {
  return (
    <div className="p-6 md:p-8">
      <div className="max-w-4xl">
        <h1 className="text-2xl font-bold text-gray-800 mb-1">Panel de administración</h1>
        <p className="text-gray-500 text-sm mb-8">Elegí una sección para gestionar el sitio.</p>

        <div className="grid gap-4 sm:grid-cols-2">
          {cards.map(({ title, description, href, icon: Icon, color, disabled }) => (
            <Link
              key={href}
              to={href}
              className={`rounded-xl border bg-white p-5 shadow-sm transition-all hover:shadow-md ${
                disabled ? 'pointer-events-none opacity-60' : 'hover:border-purple-200'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className={`rounded-lg p-2.5 ${color} text-white shrink-0`}>
                  <Icon className="w-6 h-6" />
                </div>
                <div className="min-w-0 flex-1">
                  <h2 className="font-semibold text-gray-800 flex items-center gap-2">
                    {title}
                    {!disabled && <ArrowRight className="w-4 h-4 text-gray-400" />}
                  </h2>
                  <p className="text-sm text-gray-500 mt-0.5">{description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
